import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/authentication/auth.service';
import { AlertService } from '../../services/alert.service';
import { ViewBaseComponent } from '../../views/view-base.component';
import { Personnel } from '../../services/personnel/personnel'
import { PersonnelService } from '../../services/personnel/personnel.service'
import { AppGlobals } from '../../app.globals'
import DataSource from 'devextreme/data/data_source';

@Component({
  templateUrl: 'signaletique-grille.component.html'
})
export class SignaletiqueGrilleComponent extends ViewBaseComponent implements OnInit {

  personnel: Personnel[] = [];

  constructor(
    protected authService: AuthService,
    protected alertService: AlertService,
    protected personnelService: PersonnelService,
    private router: Router) {
    super(authService, alertService);
  }

  getPersonnel() {
    this.personnelService.getPersonnel().subscribe(
      personnel => {
        this.personnel = personnel;
      }
    );
  }

  ngOnInit() {
    this.getPersonnel();
  }

  openSignaletique(clePerso: number) {
    this.router.navigate([ `admin/signaletique/${clePerso}` ]);
  }

  openAgenda(clePerso: number) {
     this.router.navigate([ `presta/agenda/${clePerso}` ]);
  }

  dateToStr(date: Date) : string {
     return AppGlobals.dateToStr(date);
  }

}
